export class Deferred extends Promise {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(executor = () => {}) {
    let _resolve;
    let _reject;
    super((resolve, reject) => {
      _resolve = resolve;
      _reject = reject;
      executor(resolve, reject);
    });
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.resolve = _resolve;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.reject = _reject;
  }
  resolve;
  reject;
}
